<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="stepTitle"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (!initialized) {
      <tidy-row [align]="'center'">
        <tidy-loader />
      </tidy-row>
    }

    @if (initialized) {
    <!-- ===== SECTION 1: LOCATION ===== -->
    <div class="tl-section tl-first">
      <div class="tl-track" [class.completed]="currentStep > 1">
        <div class="tl-dot"
          [class.active]="currentStep === 1"
          [class.completed]="currentStep > 1"></div>
      </div>
      <div class="tl-content">
        <div class="tl-step-header"
          [class.active-header]="currentStep === 1"
          (click)="goToStep(1)">
          <tidy-text [header]="'Location'" />
        </div>
        <div class="tl-body">
          @if (currentStep === 1) {
            <form [formGroup]="form">
              <tidy-select
                [form]="form.controls.addressId"
                formControlName="addressId"
                [items]="addressFilterItems"
                [icon]="'assets/svg/location.svg'"
                (optionChange)="onAddressChange($event)" />
            </form>
            <div class="button-row">
              <tidy-button
                [text]="'Continue'"
                [action]="goNext"
                [disabled]="!locationStepValid"
                class="primary" />
            </div>
          } @else if (currentStep > 1 && address) {
            <div class="tl-summary" (click)="goToStep(1)">
              <tidy-text [body]="address.address_name || address.address1" />
            </div>
          }
        </div>
      </div>
    </div>

    <!-- ===== SECTION 2: SERVICE ===== -->
    @if (showNonCleaningServices) {
      <div class="tl-section">
        <div class="tl-track" [class.completed]="currentStep > 2">
          <div class="tl-dot"
            [class.active]="currentStep === 2"
            [class.completed]="currentStep > 2"
            [class.locked]="highestStepReached < 2"></div>
        </div>
        <div class="tl-content">
          <div class="tl-step-header"
            [class.locked]="highestStepReached < 2"
            [class.active-header]="currentStep === 2"
            (click)="goToStep(2)">
            <tidy-text [header]="'Service'" />
          </div>
          <div class="tl-body">
            @if (currentStep === 2) {
              @if (proSelectItems.length > 1) {
                <form [formGroup]="form">
                  <tidy-select
                    class="fit-content"
                    [form]="form.controls.proSelect"
                    formControlName="proSelect"
                    [items]="proSelectItems"
                    [icon]="'assets/svg/person.svg'"
                    (optionChange)="onProSelected($event)" />
                </form>
              }

              @if (selectedProId === 'new') {
                <div [class.category-mode-compact]="!windowService.isDesktopRes">
                  <div class="category-tab-bar-wrapper">
                    @if (showTabLeftArrow) {
                      <div class="category-tab-arrow category-tab-arrow-left" (click)="scrollTabBarLeft()">
                        <img src="assets/svg/chevron-back-outline.svg" class="category-tab-arrow-icon" />
                      </div>
                    }
                    <div class="category-tab-bar" #categoryTabBar (scroll)="onTabBarScroll()">
                      @for (cat of filteredMainCategories; track cat.id) {
                        <div
                          class="category-tab"
                          [class.category-tab-active]="selectedMainCategory?.id === cat.id"
                          (click)="selectMainCategory(cat)">
                          <img [src]="cat.icon" class="category-tab-icon" />
                          <tidy-text [helper]="cat.name" />
                        </div>
                      }
                    </div>
                    @if (showTabRightArrow) {
                      <div class="category-tab-arrow category-tab-arrow-right" (click)="scrollTabBarRight()">
                        <img src="assets/svg/chevron-forward-outline.svg" class="category-tab-arrow-icon" />
                      </div>
                    }
                  </div>
                </div>
              }

              <div [class.category-mode-compact]="!windowService.isDesktopRes">
                <div class="subcategory-grid">
                  @for (sub of filteredSubcategories; track sub.apiKey) {
                    <tidy-card
                      class="subcategory-card small-padding"
                      (click)="selectSubcategory(sub)">
                      <div class="subcategory-card-inner">
                        <tidy-radio-button
                          class="radio-card-title subcategory-radio"
                          [ngModel]="selectedSubcategory?.apiKey"
                          [ngModelOptions]="{standalone: true}"
                          [items]="[{value: sub.apiKey, viewValue: sub.name}]" />
                        @if (sub.popular) {
                          <span class="popular-tag">Popular</span>
                        }
                      </div>
                    </tidy-card>
                  }
                </div>
              </div>

              @if (filteredSubcategories.length === 0) {
                <tidy-row [align]="'center'">
                  <tidy-text [helper]="'No services match your search.'" />
                </tidy-row>
              }

              <div class="button-row">
                <tidy-button
                  [text]="'Continue'"
                  [action]="goNext"
                  [disabled]="!categoryStepValid"
                  class="primary" />
              </div>
            } @else if (currentStep > 2 && selectedCategory) {
              <div class="tl-summary" (click)="goToStep(2)">
                <tidy-text [body]="selectedCategory.viewValue" />
              </div>
            }
          </div>
        </div>
      </div>
    }

    <!-- ===== SECTION 3: DETAILS ===== -->
    <div class="tl-section">
      <div class="tl-track" [class.completed]="currentStep > 3">
        <div class="tl-dot"
          [class.active]="currentStep === 3"
          [class.completed]="currentStep > 3"
          [class.locked]="highestStepReached < 3"></div>
      </div>
      <div class="tl-content">
        <div class="tl-step-header"
          [class.locked]="highestStepReached < 3"
          [class.active-header]="currentStep === 3"
          (click)="goToStep(3)">
          <tidy-text [header]="'Details'" />
        </div>
        <div class="tl-body">
          @if (currentStep === 3) {
            @if (!showNonCleaningServices && proSelectItems.length > 1) {
              <form [formGroup]="form">
                <tidy-select
                  class="fit-content"
                  [form]="form.controls.proSelect"
                  formControlName="proSelect"
                  [items]="proSelectItems"
                  [icon]="'assets/svg/person.svg'"
                  (optionChange)="onProSelectedInDetailsStep($event)" />
              </form>
            }

            @if (!loaded && !errorMessage) {
              <tidy-row [align]="'center'">
                <tidy-loader />
              </tidy-row>
            }

            @if (!loaded && errorMessage) {
              <tidy-error-message
                [text]="errorMessage" />
            }

            @if (loaded) {
              @if (!hideServiceCards && isHouseCleaning) {
                @for (service of services; track service; let i = $index) {
                  <tidy-card>
                    <tidy-card-button (action)="handleServiceClick(service)" [hideArrow]="true">
                      <tidy-row>
                        <tidy-row class="vertical-align-center">
                          <form [formGroup]="form" novalidate action="#">
                            <tidy-radio-button
                              formControlName="service"
                              class="radio-card-title"
                              [form]="form.controls.service"
                              [items]="[{value: service.key, viewValue: service.title | titlecase}]" />
                          </form>
                          @if (servicePopularFlags[service.key]) {
                            <span
                              class="service-popular-tag"
                              [class.service-popular-tag-selected]="form.value.service === service.key">POPULAR</span>
                          }
                        </tidy-row>
                        <tidy-row>
                          <tidy-text
                            [body]="servicePriceTexts[service.key]" />
                          <tidy-text
                            [body]="service.description" />
                        </tidy-row>
                      </tidy-row>
                      @if (form.value.service === service.key && !configuration?.hide_frequency) {
                        <tidy-row>
                          <tidy-divider />
                        </tidy-row>
                        <tidy-row class="no-padding">
                          <form [formGroup]="form" novalidate action="#">
                            <tidy-radio-button
                              [hideItemValues]="['every_day', 'thrice_a_week', 'twice_a_week']"
                              chunkSize="2"
                              formControlName="frequency"
                              (optionChange)="selectFrequency($event)"
                              [form]="form.controls.frequency"
                              [items]="service.frequencies"
                              (showAllOptions)="showAllFrequencies()"
                              [ordenation]="frequencyOrder"
                              [sameRow]="true" />
                          </form>
                        </tidy-row>
                      }
                    </tidy-card-button>
                  </tidy-card>
                }

                @if (showSavingsText) {
                  <tidy-row [align]="'center'">
                    <tidy-text
                      [smallBody]="savingsTextValue" />
                  </tidy-row>
                }
              }

              @if (bookingForms) {
                <dynamic-booking-form
                  #dynamicBookingForm
                  [forms]="bookingForms"
                  [submitted]="submitted" />
              } @else if (noBookingFormsAvailable && !isHouseCleaning && !hideServiceCards) {
                <tidy-alert>
                  <tidy-row>
                    <tidy-text [body]="'Need to add booking forms for this service.'" />
                  </tidy-row>
                </tidy-alert>
              }

              <div class="button-row">
                <tidy-button
                  [text]="'Back'"
                  [action]="goBack"
                  class="secondary" />
                <tidy-button
                  [text]="'Continue'"
                  [action]="goNext"
                  [disabled]="!step2Valid"
                  class="primary" />
              </div>
            }
          } @else if (currentStep > 3) {
            <div class="tl-summary" (click)="goToStep(3)">
              @if (isHouseCleaning && selectedServiceData) {
                <tidy-text [body]="(selectedService | titlecase) + ' · ' + selectedFrequency" />
              } @else if (detailsSummaryItems?.length) {
                <div class="details-summary">
                  @for (item of detailsSummaryItems; track item.label) {
                    <div class="details-summary-item">
                      @if (item.value) {
                        <tidy-text [body]="item.label + ': ' + item.value" />
                      }
                      @if (item.imageUrls?.length) {
                        <tidy-text [body]="item.label + ':'" />
                        <div class="details-summary-images">
                          @for (url of item.imageUrls; track url) {
                            <img [src]="url" class="details-summary-thumb" />
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              } @else {
                <tidy-text [body]="selectedCategory?.viewValue" />
              }
            </div>
          }
        </div>
      </div>
    </div>

    <!-- ===== SECTION 4: DATE & TIME ===== -->
    <div class="tl-section">
      <div class="tl-track" [class.completed]="currentStep > 4">
        <div class="tl-dot"
          [class.active]="currentStep === 4"
          [class.completed]="currentStep > 4"
          [class.locked]="highestStepReached < 4"></div>
      </div>
      <div class="tl-content">
        <div class="tl-step-header"
          [class.locked]="highestStepReached < 4"
          [class.active-header]="currentStep === 4"
          (click)="goToStep(4)">
          <tidy-text [header]="'Date & Time'" />
        </div>
        <div class="tl-body">
          @if (currentStep === 4) {

            @if (!hasSelectedPro && hasResolvedStarRatingFilter) {
              <form [formGroup]="form" style="padding-top: 10px;">
                <tidy-select
                  class="fit-content"
                  [form]="form.controls.proOption"
                  formControlName="proOption"
                  [items]="starRatingFilterItems"
                  [icon]="'assets/svg/filter.svg'"
                  (optionChange)="changeStarRatingFilter($event)" />
              </form>
            }

            @if (hasSelectedPro && !showProRequestView && !noAvailableTimes && !isLoadingTimes && !inMultiTimeMode && !inRescheduleMode) {
              <tidy-row class="white-link">
                <tidy-text [body]="selectedProName + (' not available?' | translate)" />
                <span>&nbsp;</span>
                <tidy-text
                  [actionBody]="'Send them a request'"
                  (action)="switchToProRequestView()"
                  class="white-link"/>
              </tidy-row>
            }

            @if (inProRequestMode) {
              <tidy-row>
                <tidy-text
                  [actionBody]="'← Go back to see available times'"
                  (action)="switchToAvailableTimes()"
                  class="white-link" />
              </tidy-row>
            }

            @if (!inMultiTimeMode && !hasSelectedPro && showSelectTime && !showRequestTimeView && !isLoadingTimes && dateTimes?.length > 0 && !inRescheduleMode) {
              <tidy-row class="white-link">
                <tidy-text [body]="'Don\'t see a time you like?'" />
                &nbsp;
                <tidy-text
                  [actionBody]="'Request time'"
                  (action)="switchToRequestTimeView()"
                  class="white-link" />
              </tidy-row>
            }

            @if (!hasSelectedPro && showSelectTime && showRequestTimeView) {
              <tidy-row>
                <tidy-text
                  [actionBody]="'← Go back to see confirmed times'"
                  (action)="switchToConfirmedTimes()"
                  class="white-link" />
              </tidy-row>
            }

            @if (inMultiTimeMode || (hasSelectedPro && !showProRequestView) || (!hasSelectedPro && showSelectTime && !showRequestTimeView)) {
              @if (isLoadingTimes) {
                <tidy-row [align]="'center'">
                  <tidy-loader />
                </tidy-row>
              }

              @if (!isLoadingTimes && noAvailableTimes && !selectedPrivatePro) {
                <tidy-alert>
                  @if (minRateToBookWithPro) {
                    <tidy-row [align]="'center'">
                      <tidy-text [header]="'Raise Rates to Book'" />
                    </tidy-row>
                    <tidy-row [align]="'center'">
                      <tidy-text [body]="proNotBookableReason?.not_bookable_reason" />
                    </tidy-row>
                    <tidy-row>
                      <tidy-button
                        [text]="('Change Rates to ' | translate) + (minRateToBookWithPro | tcurrency)"
                        [action]="changeServiceRates"
                        class="primary full-width" />
                    </tidy-row>
                    <tidy-row [align]="'center'" class="extra-bottom-padding">
                      <tidy-text [body]="'You can also'" /><span>&nbsp;</span>
                      <tidy-text
                        [body]="('request a job with ' | translate) + selectedProName"
                        (action)="switchToProRequestView()"
                        class="white-link"
                        [rippleEffect]="false" /><span>&nbsp;</span>
                      <tidy-text [body]="'and they may still accept at your current rates.'" />
                    </tidy-row>
                    <tidy-row [align]="'center'">
                      <tidy-text
                        [actionBody]="'Click here'"
                        (action)="viewAllAvailability()"
                        class="white-link" /><span>&nbsp;</span>
                      <tidy-text [body]="'to book with a new pro.'" />
                    </tidy-row>
                  } @else if (hasSelectedPro && proNotBookableReason) {
                    <tidy-row [align]="'center'">
                      <tidy-text [header]="notBookableHeader" />
                    </tidy-row>
                    <tidy-row [align]="'center'" class="extra-bottom-padding">
                      <tidy-text [body]="proNotBookableReason?.text" />
                      @if (proNotBookableReason?.request_eligible) {
                        <span>&nbsp;</span>
                        <tidy-text
                          [actionBody]="('Request Job with ' | translate) + selectedProName"
                          (action)="switchToProRequestView()"
                          class="white-link" />
                      }
                    </tidy-row>
                    <tidy-row [align]="'center'">
                      <tidy-text
                        [actionBody]="'Click here'"
                        (action)="viewAllAvailability()"
                        class="white-link" /><span>&nbsp;</span>
                      <tidy-text [body]="'to book with a new pro.'" />
                    </tidy-row>
                  } @else {
                    <tidy-row [align]="'center'">
                      <tidy-text [body]="'No available times found. Please try a different service or date range.'" />
                    </tidy-row>
                  }
                </tidy-alert>
              }

              @if (!isLoadingTimes && selectedPrivatePro) {
                <tidy-card>
                  <tidy-row>
                    <form [formGroup]="form">
                      <tidy-select
                        [label]="'Select Date'"
                        [icon]="'assets/svg/calendar.svg'"
                        [form]="form.controls.privateDate"
                        formControlName="privateDate"
                        [items]="privateJobDates"
                        (optionChange)="changeDay($event)" />
                    </form>
                  </tidy-row>
                  @if (isLoadingPrivateTimes) {
                    <tidy-row [align]="'center'">
                      <tidy-loader />
                    </tidy-row>
                  }
                  @if (!isLoadingPrivateTimes && noAvailableTimes) {
                    <tidy-row [align]="'center'">
                      <tidy-text [body]="'No Times Available'" />
                    </tidy-row>
                  }
                  @if (!isLoadingPrivateTimes && !noAvailableTimes && dateTimes?.length) {
                    <form [formGroup]="form" novalidate action="#">
                      <tidy-radio-button
                        chunkSize="3"
                        formControlName="time"
                        (optionChange)="selectTime($event)"
                        [form]="form.controls.time"
                        [items]="dateTimes[0]?.times" />
                    </form>
                  }
                </tidy-card>
              }

              @if (!isLoadingTimes && !noAvailableTimes && !selectedPrivatePro) {
                @if (inMultiTimeMode) {
                  @for (selected of allTimesSelected; track selected.value; let i = $index) {
                    <div class="multi-time-summary-card">
                      <div class="multi-time-summary-inner">
                        <div>
                          <tidy-text [helper]="multiTimeOrdinalLabels[i]" />
                          <tidy-text [body]="multiTimeSummaryTexts[i]" />
                        </div>
                        <tidy-text
                          [actionBody]="'Edit'"
                          (action)="editMultiTime(i)"
                          class="white-link" />
                      </div>
                    </div>
                  }
                  <tidy-row>
                    <tidy-text [title]="multiTimeLabelText" />
                  </tidy-row>
                  @for (item of filteredDateTimesForStep; track item.date) {
                    <tidy-card>
                      <tidy-row>
                        <tidy-text
                          [header]="item.date | parseDateTime:'dddd MMM d':''" />
                      </tidy-row>
                      <form [formGroup]="form" novalidate action="#">
                        <tidy-radio-button
                          chunkSize="3"
                          formControlName="time"
                          (optionChange)="selectTime($event)"
                          [form]="form.controls.time"
                          [items]="item.times" />
                      </form>
                    </tidy-card>
                  }
                } @else {
                  @for (item of dateTimes; track item.date) {
                    @if (!timeCardsCollapsed || item.date === selectedTimeDate) {
                      <tidy-card>
                        <tidy-row>
                          <tidy-text
                            [header]="item.date | parseDateTime:'dddd MMM d':''" />
                        </tidy-row>
                        <form [formGroup]="form" novalidate action="#">
                          <tidy-radio-button
                            chunkSize="3"
                            formControlName="time"
                            (optionChange)="selectTime($event)"
                            [form]="form.controls.time"
                            [items]="item.times" />
                        </form>
                      </tidy-card>
                    }
                  }
                  @if (timeCardsCollapsed) {
                    <tidy-row [align]="'center'">
                      <tidy-text
                        [actionBody]="'Show More Days'"
                        (action)="toggleTimeCards()"
                        class="white-link" />
                    </tidy-row>
                  }
                }
              }

              @if (!inMultiTimeMode && hasSelectedPro && !isLoadingTimes && !noAvailableTimes && dateTimes?.length > 0) {
                <tidy-row [align]="'center'">
                  <tidy-text [body]="'Don\'t see a time you like?'" />
                </tidy-row>
                <tidy-row [align]="'center'">
                  <tidy-text
                    [actionBody]="'Click here'"
                    (action)="viewAllAvailability()"
                    class="white-link" /><span>&nbsp;</span>
                  <tidy-text [body]="'to book with a new pro.'" />
                </tidy-row>
              }

            } @else if (inProRequestMode) {
              <tidy-text [title]="'Select Time(s)'" />
              @if (proRequestNotSelectedTimesError) {
                <tidy-error-message [text]="'Please select a time.'" />
              }
              @for (day of proRequestDays; track day; let dayIndex = $index) {
                <tidy-card>
                  <tidy-row class="vertical-align-center">
                    <ng-container [formGroup]="proRequestWeekDayCheckBox[dayIndex]">
                      <tidy-checkbox
                        [items]="[{viewValue: day?.displayFormat, value: true}]"
                        (checkedChange)="proRequestMarkCheckbox($event, dayIndex)"
                        formControlName="checked"
                        [checked]="proRequestWeekDayCheckBox[dayIndex].value.checked"
                        [initValue]="proRequestWeekDayCheckBox[dayIndex].value.checked" />
                    </ng-container>
                  </tidy-row>
                  @for (formGrp of proRequestTimeRangeForms[dayIndex]; track formGrp; let i = $index) {
                    <div [formGroup]="formGrp" class="pro-request-time-row">
                      <tidy-select
                        class="pro-request-time-select"
                        [icon]="'assets/svg/time.svg'"
                        [label]="'Time'"
                        [form]="formGrp.controls.start_time"
                        formControlName="start_time"
                        errorMessage="Select a valid time"
                        [submitted]="true"
                        (optionChange)="proRequestUpdateValuesValidity(); proRequestStartTimeChange(formGrp)"
                        [items]="dayIndex === 0 ? proRequestTodayStartOpts : proRequestTimeOpts" />
                      <span class="pro-request-time-dash">-</span>
                      <tidy-select
                        class="pro-request-time-select"
                        [icon]="'assets/svg/time.svg'"
                        [label]="'Time'"
                        [form]="formGrp.controls.end_time"
                        formControlName="end_time"
                        errorMessage="Select a valid time"
                        [submitted]="true"
                        (optionChange)="proRequestUpdateValuesValidity()"
                        [items]="proRequestEndTimeOptions[dayIndex][i]" />
                      <tidy-image
                        (action)="proRequestRemoveTimeRange(dayIndex, i)"
                        src="assets/img/trash-icon-outline.svg"
                        class="icon body-size pro-request-time-icon" />
                      <tidy-image
                        (action)="proRequestAddNewTimeRange(dayIndex)"
                        src="assets/img/add.svg"
                        class="icon body-size white-icon pro-request-time-icon" />
                    </div>
                  }
                </tidy-card>
              }
            } @else {
              <tidy-text [body]="'Select days and times that work for you. We\'ll check availability and let you know when we confirm a time.'" />
              <form [formGroup]="form" novalidate action="#">
                <tidy-row class="field-bottom-padding extra-top-padding">
                  <tidy-text [header]="'Earliest Start'" />
                </tidy-row>
                <tidy-row>
                  <tidy-two-column-row>
                    <tidy-datepicker
                      style="padding-right:10px"
                      [label]="'Date'"
                      [icon]="'assets/svg/calendar.svg'"
                      formControlName="rangeStartDate"
                      [form]="form.controls.rangeStartDate"
                      [noPastDates]="true"
                      (optionChange)="onDateRangeChanged({start: $event, end: form.value.rangeEndDate})" />
                    <tidy-select
                      [icon]="'assets/svg/time.svg'"
                      [label]="'Time'"
                      [items]="proRequestTimeOpts"
                      formControlName="noEarlierTime"
                      [form]="form.controls.noEarlierTime"
                      [hideSearch]="true"
                      (optionChange)="selectNoEarlierTime($event)" />
                  </tidy-two-column-row>
                </tidy-row>
                <tidy-row class="extra-top-padding field-bottom-padding">
                  <tidy-text [header]="'Latest Finish'" />
                </tidy-row>
                <tidy-row>
                  <tidy-two-column-row>
                    <tidy-datepicker
                      style="padding-right:10px"
                      [label]="'Date'"
                      [icon]="'assets/svg/calendar.svg'"
                      formControlName="rangeEndDate"
                      [form]="form.controls.rangeEndDate"
                      [minDate]="form.controls.rangeStartDate.value"
                      (optionChange)="onDateRangeChanged({start: form.value.rangeStartDate, end: $event})" />
                    <tidy-select
                      [icon]="'assets/svg/time.svg'"
                      [label]="'Time'"
                      [items]="proRequestTimeOpts"
                      formControlName="noLaterTime"
                      [form]="form.controls.noLaterTime"
                      [hideSearch]="true"
                      (optionChange)="selectNoLaterTime($event)" />
                  </tidy-two-column-row>
                </tidy-row>
              </form>
            }

            @if (showSameDayTimeAlert && !selectedPrivatePro && dateRangeStart) {
              <tidy-alert>
                <tidy-row>
                  <tidy-text
                    [body]="'<b>Note:</b> You selected times today. If a pro accepts a time today <u>the price will be +50%.</u>'" />
                </tidy-row>
              </tidy-alert>
            }

            <div class="button-row">
              <tidy-button
                [text]="'Back'"
                [action]="goBack"
                class="secondary" />
              <tidy-button
                [text]="'Continue'"
                [action]="goNext"
                [disabled]="!step3Valid"
                class="primary" />
            </div>
          } @else if (currentStep > 4) {
            <div class="tl-summary" (click)="goToStep(4)">
              <tidy-text [body]="dateTimeSummary" />
            </div>
          }
        </div>
      </div>
    </div>

    <!-- ===== SECTION 5: CONFIRM & PAY ===== -->
    <div class="tl-section tl-last">
      <div class="tl-track">
        <div class="tl-dot"
          [class.active]="currentStep === 5"
          [class.locked]="highestStepReached < 5"></div>
      </div>
      <div class="tl-content">
        <div class="tl-step-header"
          [class.locked]="highestStepReached < 5"
          [class.active-header]="currentStep === 5"
          (click)="goToStep(5)">
          <tidy-text [header]="hasValidCC ? 'Confirm' : 'Confirm & Pay'" />
        </div>
        <div class="tl-body">
          @if (currentStep === 5) {
            @if (customFlowName) {
              <tidy-row>
                <tidy-text
                  [body]="customFlowName" /><span>&nbsp;</span>
                <tidy-text
                  [body]="'offers a'" /><span>&nbsp;</span>
                <tidy-text
                  [body]="customFlowDiscount" /><span>&nbsp;</span>
                <tidy-text
                  [body]="'% discount on all cleanings.'" />
              </tidy-row>
            }

            @if (hasValidCC) {
              <tidy-card>
                <div class="summary-item">
                  <tidy-image
                    [src]="'assets/svg/location-outline.svg'"
                    class="summary-icon" />
                  <div class="summary-text">
                    <tidy-text [helper]="'Location'" />
                    <tidy-text [body]="address?.address_name || address?.address1" />
                  </div>
                </div>
                <div class="summary-item">
                  @if (isHouseCleaning && selectedServiceData) {
                    <tidy-image
                      [src]="'https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning.svg'"
                      class="summary-icon" />
                    <div class="summary-text">
                      <tidy-text [helper]="'Service'" />
                      <tidy-text [body]="(selectedService | titlecase) + ' · ' + selectedFrequency" />
                    </div>
                  } @else {
                    <tidy-image
                      [src]="selectedServiceImage || selectedCategory?.icon || 'assets/svg/home-outline.svg'"
                      class="summary-icon" />
                    <div class="summary-text">
                      <tidy-text [helper]="'Service'" />
                      <tidy-text [body]="selectedCategory?.viewValue" />
                    </div>
                  }
                </div>
                <div class="summary-item">
                  <tidy-image
                    [src]="'assets/svg/calendar-outline.svg'"
                    class="summary-icon" />
                  <div class="summary-text">
                    <tidy-text [helper]="'Date & Time'" />
                    <tidy-text [body]="dateTimeSummary" />
                  </div>
                </div>
                @if (selectedProId !== 'new' && selectedProName) {
                  <div class="summary-item">
                    <tidy-image
                      [src]="'assets/svg/person-outline.svg'"
                      class="summary-icon" />
                    <div class="summary-text">
                      <tidy-text [helper]="'Pro'" />
                      <tidy-text [body]="selectedProName" />
                    </div>
                  </div>
                }
                <div class="summary-item">
                  <tidy-image
                    [src]="'assets/svg/cash-outline.svg'"
                    class="summary-icon" />
                  <div class="summary-text">
                    <tidy-text [helper]="'Price'" />
                    <tidy-text [body]="showSameDayTimeAlert && !selectedPrivatePro ? priceBodyText + '*' : priceBodyText" />
                  </div>
                </div>
                @if (showSameDayTimeAlert && !selectedPrivatePro) {
                  <div class="summary-item">
                    <div class="summary-icon"></div>
                    <div class="summary-text">
                      @if (sameDayPrice !== 0) {
                        <tidy-text
                          [body]="('<b>*Note:</b> You selected times today. If a pro accepts a time today <u>the price will be ' | translate) + (sameDayPrice | tcurrency) + '</u>.'" />
                      }
                      @if (sameDayPrice == 0) {
                        <tidy-text
                          [body]="'<b>*Note:</b> You selected times today. If a pro accepts a time today <u>the price will be +50%</u>.'" />
                      }
                    </div>
                  </div>
                }
              </tidy-card>
            }

            @if (!hasValidCC) {
              <tidy-card>
                <tidy-row class="no-padding">
                  <ion-row>
                    <tidy-row style="align-self: flex-start">
                      <tidy-image
                        [src]="isHouseCleaning ? 'https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning.svg' : (selectedServiceImage || selectedCategory?.icon || 'https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning.svg')"
                        style="width: 30px" />
                    </tidy-row>
                    <ion-col>
                      <tidy-row>
                        <tidy-text [header]="selectedService | titlecase" />
                      </tidy-row>
                      @if (selectedFrequency) {
                        <tidy-row>
                          <tidy-text [body]="selectedFrequency" />
                        </tidy-row>
                      }
                      @if (dateTimeSummary) {
                        <tidy-row>
                          <tidy-text [body]="dateTimeSummary" />
                        </tidy-row>
                      }
                    </ion-col>
                  </ion-row>
                </tidy-row>
                <tidy-row class="extra-top-padding extra-bottom-padding">
                  <tidy-divider />
                </tidy-row>
                @if (creditBalance > 0) {
                  <tidy-row class="vertical-align-center">
                    <tidy-image
                      [src]="'assets/svg/checkmark-circle.svg'"
                      class="header-size white-icon" />
                    <tidy-text
                      [header]="'Credit Applied'" />
                  </tidy-row>
                  <tidy-row>
                    @if (creditBalance < viewData?.price) {
                      <tidy-text
                        [body]="'You have'" /><span>&nbsp;</span>
                      <tidy-text
                        [body]="creditBalance | tcurrency" /><span>&nbsp;</span>
                      <tidy-text
                        [body]="'in credit that will automatically be used for this job.'" />
                    }
                    @if (creditBalance >= viewData?.price) {
                      <tidy-text
                        [body]="'You have'" /><span>&nbsp;</span>
                      <tidy-text
                        [body]="creditBalance | tcurrency" /><span>&nbsp;</span>
                      <tidy-text
                        [body]="'in credit, enough to pay for this job in full. We still require a card on file but you will not be charged.'" />
                    }
                  </tidy-row>
                  <tidy-row class="extra-top-padding extra-bottom-padding">
                    <tidy-divider />
                  </tidy-row>
                }
                @if (!isZeroCostService) {
                  <tidy-row>
                    <form [formGroup]="form">
                      <tidy-radio-button
                        [label]="'How do you want to pay?'"
                        formControlName="chargeType"
                        [form]="form.controls.chargeType"
                        [items]="paymentOptions"
                        class="no-margin-first"
                        (optionChange)="changePrice($event)" />
                    </form>
                  </tidy-row>
                } @else {
                  <tidy-row class="extra-bottom-padding">
                    <tidy-text [body]="'This type of job is typically priced after. We\'ll find the best pro and you can discuss pricing with them. Please add a credit card to secure the job. '" />
                  </tidy-row>
                  <tidy-row>
                    <tidy-text [body]="'<b>You will not be charged until the job is complete.</b>'" />
                  </tidy-row>
                }
                @if (showSameDayTimeAlert && !selectedPrivatePro) {
                  <tidy-row class="extra-top-padding">
                    @if (sameDayPrice !== 0) {
                      <tidy-text
                        [body]="'<b>*Note:</b> You selected times today. If a Pro accepts a time today the job price will be'" /><span>&nbsp;</span>
                      <tidy-text
                        [body]="(sameDayPrice | tcurrency) + '.'" />
                    }
                    @if (sameDayPrice == 0) {
                      <tidy-text
                        [body]="'<b>*Note:</b> You selected times today. If a Pro accepts a time today <u>the price will be +50%</u>.'" />
                    }
                  </tidy-row>
                }
                <tidy-row>
                  <form class="checkout">
                    <div class="form-row">
                      <div id="card-info" #cardInfo></div>
                    </div>
                  </form>
                </tidy-row>
                @if (!giftCode && !customFlowName) {
                  <tidy-row class="vertical-align-center extra-top-padding" [alignLastItemRight]="true">
                    <tidy-text
                      [body]="'Referral / Gift Code'"
                      (action)="giftCodeForm = true"
                      class="white-link" />
                    <div class="vertical-align-center">
                      <tidy-checkbox
                        [(checked)]="termsChecked"
                        [items]="[{viewValue: '', value: true}]"
                        [initValue]="termsChecked" />
                      <tidy-text
                        [body]="'I agree to the'" /><span>&nbsp;</span>
                      <tidy-text
                        (action)="openTerms()"
                        [body]="'terms'"
                        class="white-link no-left-margin" />
                    </div>
                  </tidy-row>
                } @else {
                  <tidy-row class="vertical-align-center">
                    <tidy-checkbox
                      [(checked)]="termsChecked"
                      [items]="[{viewValue: '', value: true}]"
                      [initValue]="termsChecked" />
                    <tidy-text
                      [body]="'I agree to the'" /><span>&nbsp;</span>
                    <tidy-text
                      (action)="openTerms()"
                      [body]="'terms'"
                      [rippleEffect]="false"
                      class="white-link no-left-margin" />
                  </tidy-row>
                }
                @if (giftCodeForm) {
                  <tidy-row class="extra-top-padding">
                    <form [formGroup]="giftForm">
                      <tidy-input
                        [label]="'Referral/Gift Code'"
                        [icon]="'assets/svg/gift.svg'"
                        formControlName="giftCode"
                        [form]="giftForm.controls.giftCode" />
                    </form>
                  </tidy-row>
                  @if (giftCodeErrorMessage && giftForm?.value?.giftCode) {
                    <tidy-row class="extra-bottom-padding">
                      <tidy-text
                        [body]="giftCodeErrorMessage"
                        class="red" />
                    </tidy-row>
                  }
                  @if (giftCode && !giftCodeErrorMessage) {
                    <tidy-row class="extra-bottom-padding">
                      <tidy-text
                        [body]="'Code successfully applied!'"
                        class="green" />
                    </tidy-row>
                  }
                }
                @if (customFlowName) {
                  <tidy-row>
                    <tidy-text
                      [header]="'Enter Contact Detail'" />
                  </tidy-row>
                  <form [formGroup]="form">
                    <tidy-row class="field-top-padding field-bottom-padding">
                      <tidy-input
                        formControlName="firstName"
                        [form]="form.controls.firstName"
                        [label]="'First Name'"
                        [errorMessage]="'Please enter your first name.'"
                        [submitted]="submitted"
                        [icon]="'assets/svg/person.svg'" />
                    </tidy-row>
                    <tidy-row class="field-bottom-padding">
                      <tidy-input
                        formControlName="lastName"
                        [form]="form.controls.lastName"
                        [label]="'Last Name'"
                        [errorMessage]="'Please enter your last name.'"
                        [submitted]="submitted"
                        [icon]="'assets/svg/person.svg'" />
                    </tidy-row>
                    <tidy-row class="field-bottom-padding">
                      <tidy-input
                        formControlName="email"
                        [form]="form.controls.email"
                        [label]="'Email'"
                        type="email"
                        [errorMessage]="'Please enter a valid email.'"
                        [submitted]="submitted"
                        [icon]="'assets/svg/mail.svg'" />
                    </tidy-row>
                    <tidy-row>
                      <tidy-input-international-phone
                        formControlName="phone"
                        [label]="'Phone'"
                        [form]="form.controls.phone"
                        [inputMode]="'numeric'"
                        [submitted]="submitted"
                        [errorMessage]="'Please enter a valid phone.'"
                        [icon]="'assets/svg/phone-portrait.svg'"
                        [initialMask]="{ mask: '[00000000000000000000000]' }"
                        (countryCodeChange)="onCountryCodeChange($event)" />
                    </tidy-row>
                  </form>
                }
              </tidy-card>
            }

            @if (errorMessage) {
              <tidy-error-message
                [text]="errorMessage" />
            }

            @if (termsError) {
              <tidy-row>
                <tidy-error-message
                  [text]="'You must agree to the terms to continue.'" />
              </tidy-row>
            }

            <div class="button-row">
              <tidy-button
                [text]="'Back'"
                [action]="goBack"
                class="secondary" />
              <tidy-button
                [text]="buttonTitle"
                [action]="boundConfirmBooking"
                class="primary" />
            </div>

            @if (!hasValidCC) {
              <tidy-alert class="social-proof-card black-background">
                <div class="review-content">
                  <tidy-image
                    [src]="'assets/img/social-1.png'"
                    class="profile-avatar" />
                  <div class="review-text">
                    <tidy-text [header]="'Top Ranked on Google!'" />
                    <div class="testimonial-text">
                      <tidy-text
                        [helper]="'&quot;Amazing job! Her thoroughness was superb. The little things made it all the better!&quot; - Dawn R.'" />
                    </div>
                  </div>
                </div>
                <div class="google-row">
                  <tidy-image
                    [src]="'assets/img/google.svg'"
                    class="google-logo" />
                  <div class="rating-info">
                    <tidy-image
                      [src]="'assets/img/4_5_stars.svg'"
                      class="stars-image" />
                    <tidy-text [helper]="'4.5 • 1,000+ reviews'" />
                  </div>
                </div>
              </tidy-alert>

              <tidy-alert class="black-background">
                <tidy-row class="extra-bottom-padding">
                  <tidy-text
                    [header]="'Why Book With TIDY?'" />
                </tidy-row>
                @if (!selectedPrivatePro) {
                  <div class="benefit-item">
                    <tidy-image
                      [src]="'assets/svg/shield-checkmark.svg'"
                      class="benefit-icon white-icon" />
                    <div class="benefit-content">
                      <tidy-text
                        [body]="'<b>Satisfaction Guarantee</b>'" />
                      <tidy-text
                        [helper]="satisfactionGuaranteeText" />
                    </div>
                  </div>
                }
                <div class="benefit-item">
                  <tidy-image
                    [src]="'assets/svg/calendar.svg'"
                    class="benefit-icon white-icon" />
                  <div class="benefit-content">
                    <tidy-text
                      [body]="'<b>Cancel Any Time</b>'" />
                    <tidy-text
                      [helper]="'Most pros ask 24 hours notice. No long-term commitment.'" />
                  </div>
                </div>
                @if (!selectedPrivatePro) {
                  <div class="benefit-item">
                    <tidy-image
                      [src]="'assets/svg/checkmark-done-circle.svg'"
                      class="benefit-icon white-icon" />
                    <div class="benefit-content">
                      <tidy-text
                        [body]="'<b>Fully Customizable</b>'" />
                      <tidy-text
                        [helper]="customizableText" />
                    </div>
                  </div>
                }
              </tidy-alert>

              <tidy-row class="vertical-align-middle" [align]="'center'">
                @if (windowService.isDesktopRes) {
                  <tidy-image
                    [src]="'assets/svg/mail-outline.svg'"
                    class="body-size white-icon" />
                }
                <tidy-text
                  [helper]="'Need an alternate agreement? Contact '" />
                <tidy-text
                  [helper]="'sales@tidy.com'"
                  class="white-link"
                  [rippleEffect]="false"
                  (action)="util.openUrl('mailto:sales@tidy.com')" />
              </tidy-row>
            }
          }
        </div>
      </div>
    </div>
    }

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
